import React from "react";
import './brands-header-dropdown.scss';
import {useDispatch} from "react-redux";
import {Dropdown} from "../../../dropdown";
import {changeActiveBrandId} from "../../../mystuff-brands/brands-thunk";
import {useActiveBrandId} from "../../../../hooks/brands/useActiveBrandId";
import {Icon} from "@Components/icon-v2";
import {IconSize} from "@Components/icon-v2/icon.types";
import {useSortedBrandKitsFromStore} from "@Hooks/brands/useSortedBrandKitsFromStore";
import {canUserAccessBrandKits} from "@Libraries/brands-library.js";
import {BrandKitSource} from "@Components/mystuff-brands/brand-kits.types";

/**
 * The component displaying brands header dropdown in brand editor section
 * @author Afifa Saleem <afifa@250mils.com>
 */
const BrandsHeaderDropdown = ({dropdownLabelClass}) => {
    const brands = useSortedBrandKitsFromStore(),
        activeBrandId = useActiveBrandId(),
        dispatchReduxThunk = useDispatch();

    const changeActiveBrandForEditor = (val) => {
        dispatchReduxThunk(changeActiveBrandId({newActiveBrandId: val}));
    }

    return (
        <div className={'brand-heading'}>
            <div className={'title-with-brand-icon flex-row-align-center size-icon-20'}>
                <i className={'icon icon-brands -brands-icon content-body _unmargin'}/>
                <Dropdown
                    dropdownItemClasses={'body-xs'}
                    dropdownClasses={'brand-dropdown'}
                    dropdownLabelClasses={'brand-label -custom-lbl -no-hover content-body ' + dropdownLabelClass}
                    defaultDataValue={activeBrandId}
                    dropdownItems={getDropDownOptions(brands)}
                    clickHandler={(val) => {
                        changeActiveBrandForEditor(val)
                    }}
                />
            </div>
            {!canUserAccessBrandKits() ? <Icon className={'icon -icon-premium spacing-m-b-1'} icon={'icon-crown'} size={IconSize.SIZE_ICON_20}/> : ''}
        </div>
    )
}

/**
 * get all brand names for brand header dropdown
 * @param {object} brands
 * @returns array
 */
const getDropDownOptions = brands => {
    let dropdownItems = [];
    for (let i in brands) {
        dropdownItems[dropdownItems.length] = {
            label: getBrandDropdownItemMarkup(brands[i]),
            dataValue: brands[i].brandId
        };
    }
    return dropdownItems;
}

/**
 * @param {object} brand
 * @returns {JSX.Element}
 */
const getBrandDropdownItemMarkup = brand => {
    return <div className={'brand-dropdown-item'}>
            <span className={`item-label ${brand.source === BrandKitSource.HALLOWEEN_PROMOTION ? 'content-halloween': ''}`}>{brand.name}</span>
            <i className={'icon icon-check dropdown-item-icon size-icon-20'}/>
        </div>
}

export default BrandsHeaderDropdown;
